import { Address } from './Address';
import { BaseBus } from './BaseBus';
import { v_QuoteInvoiceBus } from './v_QuoteInvoiceBus';
import { v_QuoteDetailBus } from './v_QuoteDetailBus';
import { LineItemsSummary } from './LineItemsSummary';
import { v_QuoteNoteBus } from './v_QuoteNoteBus';
import { GCItem } from './GCItem';
import { CommonFunctions } from '../static/common-functions';
import { CustomPricingBus } from './CustomPricingBus';

export class AdditionalQuoteData extends BaseBus
{
    constructor(data: AdditionalQuoteData = null) {
        super(data);
        if (data !== null) {
            this.detail = new v_QuoteDetailBus(data.detail);
            this.quoteGC = data.quoteGC;
            this.address = new Address();
            this.address.set(this.detail.addressLine1, this.detail.addressLine2, this.detail.city, this.detail.stateProvince, this.detail.postalCode, this.detail.locationName);
            this.billingAddress = new Address();
            this.billingAddress.set(this.detail.billingAddressLine1, this.detail.billingAddressLine2, this.detail.billingCity, this.detail.billingStateProvince, this.detail.billingPostalCode, this.detail.billingLocationName);
            this.lineItemsSummary = data.lineItemsSummary;

            let notes = [];
            if (CommonFunctions.hasArrayValue(data.notes)) {
                for (let i = 0; i < data.notes.length; i++) {
                    let newObj: v_QuoteNoteBus = new v_QuoteNoteBus(data.notes[i]);
                    notes.push(newObj);
                }
            }
            this.notes = notes;

            this.setLineItems(data.lineItems);
            //let invLines = [];
            //if (CommonFunctions.hasArrayValue(data.lineItems)) {
            //    for (let i = 0; i < data.lineItems.length; i++) {
            //        let newObj: v_QuoteInvoiceBus = new v_QuoteInvoiceBus(data.lineItems[i]);
            //        invLines.push(newObj);
            //    }
            //}
            //this.lineItems = invLines;

        }
    }
    setLineItems(lineItems: v_QuoteInvoiceBus[], setForAdd: boolean = false) {
        let invLines = [];
        if (CommonFunctions.hasArrayValue(lineItems)) {
            for (let i = 0; i < lineItems.length; i++) {
                let newObj: v_QuoteInvoiceBus = new v_QuoteInvoiceBus(lineItems[i]);
                if (setForAdd) {
                    newObj.isAdded = true;
                    newObj.quoteInvoiceId = CommonFunctions.getGuid();
                }
                newObj.calculateTotalCost();
                invLines.push(newObj);
            }
        }

        this.lineItems = invLines;

    }
    clear() {
        this.detail = null;
        this.notes = null;
        this.quoteGC = null;
        this.address = null;
        this.billingAddress = null;
        this.lineItems = null;
        this.lineItemsSummary = null;
    }
    detail: v_QuoteDetailBus;
    notes: v_QuoteNoteBus[];
    quoteGC: GCItem[];
    lineItems: v_QuoteInvoiceBus[];
    address: Address;
    billingAddress: Address;
    lineItemsSummary: LineItemsSummary;
    acctMgr: string;
    createdBy: string;
    customPricing: CustomPricingBus;
}
